import { useQuery } from '@apollo/client';
import { QueryHookOptions } from '@apollo/client/react/types/types';
import gql from 'graphql-tag';

import {
  GetVendorBranchOrgMembers,
  GetVendorBranchOrgMembersVariables,
} from '../../athena/types/GetVendorBranchOrgMembers';

export const GET_VENDOR_BRANCH_ORG_MEMBERS = gql`
  query GetVendorBranchOrgMembers($id: String) {
    vendor {
      getVendorBranchByID(input: { id: $id }) {
        vendorBranch {
          id
          organization {
            uuid
            members {
              userToken
            }
          }
        }
      }
    }
  }
`;

const useGetVendorBranchOrgMembers = (
  options?: QueryHookOptions<GetVendorBranchOrgMembers, GetVendorBranchOrgMembersVariables>,
) => useQuery<GetVendorBranchOrgMembers>(GET_VENDOR_BRANCH_ORG_MEMBERS, options);

export default useGetVendorBranchOrgMembers;
